<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-format-list-numbered-rtl" icon-small title="گزارش آماری طرح ها" color="accent" :loading="loading">
			<v-row>
				<v-col cols="12" md="3">
				</v-col>
				<v-col cols="12" md="6">
					<date-navigator v-if="!hideDateRange" v-model="dateRange" :options="{ rangeMode: true, defaultEmpty: true }">
						<div class="text-center">
							<v-btn v-if="!hideDateRange" small color="primary" dark class="mx-1" @click="loadData">
								دریافت اطلاعات
							</v-btn>
						</div>
					</date-navigator>
				</v-col>
				<v-col cols="12" md="3" class="d-flex align-center justify-end">
					<export-excel :items="items" :headers="headers" :fileName="excelFileName">
					</export-excel>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-row>
						<v-col cols="12" md="6">
							<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="12">
							<v-data-table :height="dataTableFixedHeight - 100" fixed-header :headers="headers" :items="items" :items-per-page="500" :search="search" class="elevation-1">
								<template v-slot:item="row">
									<tr>
										<td>
											{{ row.item.loanTitle }}
										</td>
										<td>
											{{ row.item.memberCount }}
										</td>
										<td>
											{{ row.item.allLoansCount }}
										</td>
										<td>
											{{ row.item.totalLoans.toString().toPriceFormat() }}
										</td>
										<td>
											{{ row.item.totalProfitLoans.toString().toPriceFormat() }}
										</td>
										<td>
											{{ row.item.totalProfitDelayLoans.toString().toPriceFormat() }}
										</td>
										<td>
											{{ row.item.totalPaid.toString().toPriceFormat() }}
										</td>
										<td>
											{{ row.item.totalUnpaid.toString().toPriceFormat() }}
										</td>
										<td>
											{{ row.item.totalNonDueDated.toString().toPriceFormat() }}
										</td>
										<td>
											{{ row.item.allCheckoutedCount }}
										</td>
										<td>
											{{ row.item.overDueCount }}
										</td>
										<td class="text-center">
											{{ row.item.overDueAmount.toString().toPriceFormat() }}
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'LoanStatisticsReport',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				errorMessages: '',
				search: '',
				dateRange: { start: '', end: '' },
				loading: false,
				headers: [
					{
						text: 'نام طرح',
						align: 'start',
						sortable: true,
						value: 'loanTitle',
					}, {
						text: 'تعداد مشتری',
						align: 'start',
						sortable: true,
						value: 'memberCount',
					}, {
						text: 'تعداد پرونده',
						align: 'start',
						sortable: true,
						value: 'allLoansCount',
					}, {
						text: 'مجموع خالص وام ها',
						align: 'center',
						sortable: true,
						value: 'totalLoans',
					}, {
						text: 'مجموع وام ها با احتساب بهره',
						align: 'center',
						sortable: true,
						value: 'totalProfitLoans',
					}, {
						text: 'مجموع وام ها با احتساب بهره و دیرکرد',
						align: 'center',
						sortable: true,
						value: 'totalProfitDelayLoans',
					}, {
						text: 'مجموع وصول شده',
						align: 'center',
						sortable: true,
						value: 'totalPaid',
					}, {
						text: 'مجموع وصول نشده',
						align: 'center',
						sortable: true,
						value: 'totalUnpaid',
					}, {
						text: 'مجموع وصول نشده سررسید نشده',
						align: 'start',
						sortable: true,
						value: 'totalNonDueDated',
					}, {
						text: 'تعداد وام تسویه',
						align: 'start',
						sortable: true,
						value: 'allCheckoutedCount',
					}, {
						text: 'تعداد معوق ها',
						align: 'start',
						sortable: true,
						value: 'overDueCount',
					}, {
						text: 'مجموع معوق ها',
						align: 'start',
						sortable: true,
						value: 'overDueAmount',
					},
				],
				items: [],
			}
		},
		computed: {
			excelFileName() {
				let name = 'گزارش آماری طرح ها'
				if (this.dateRange.start)
					name += ' از ' + this.dateRange.start.toString().split('T')[0]
				if (this.dateRange.end)
					name += ' تا ' + this.dateRange.end.toString().split('T')[0]
				name += '.xls'
				return name
			},
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/report/LoanStatistics/?start=' + this.dateRange.start + '&end=' + this.dateRange.end, {})
					.then(
						response => {
							this.items = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
		},
	}
</script>
<style></style>
